import React from 'react';
import { useNavigate } from 'react-router-dom';

const StdDetails = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>📊 Student Details Page</h1>
        <p style={styles.description}>
          This page is for viewing detailed student information.
        </p>
        <button onClick={() => navigate(-1)} style={styles.button}>
          ← Go Back
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '2rem',
  },
  card: {
    background: 'white',
    borderRadius: '20px',
    padding: '3rem',
    textAlign: 'center',
    maxWidth: '500px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  title: {
    margin: '0 0 1rem 0',
    color: '#333',
  },
  description: {
    color: '#666',
    marginBottom: '2rem',
  },
  button: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    padding: '1rem 2rem',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1rem',
  },
};

export default StdDetails;
